import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OddsCheckerWrapper } from './styles';


const OddsChecker = ({className = 'matchcenter-rpg', isV2, type, position, sportId, competitionId, url = '' }) => {
  useEffect(() => {
    const payload = {
      detail: { 
        options: { 
          action: 'render'
        }
      }
    };
    document.dispatchEvent(new CustomEvent("Rcs:GazMcWidgets", payload));
    console.log("RcsGazMcLiveHubFE::render oddsChecker widget");
  }, []);

  return (
    <OddsCheckerWrapper 
      className={className}
      data-config={`{'template': 'oddsChecker${isV2? "V2" : ""}', 'type': '${type}', 'position': '${position}', 'sportId': '${sportId}', 'competitionId': '${competitionId}', 'url': '${url}'}`}
    >
    </OddsCheckerWrapper>
  )
}; 

OddsChecker.propTypes = {
  className: PropTypes.string,
  isV2: PropTypes.bool,
  type: PropTypes.string,
  position: PropTypes.string,
  sportId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  competitionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  url: PropTypes.string,
}

export default OddsChecker;